import { getApiBaseUrl } from "../config/api";

const VISITOR_KEY = "at_vid";
const STATIC_PATHS = new Set(["/", "/products", "/category", "/about", "/deliveries", "/contact"]);
const recent = new Map();
const DEDUPE_MS = 2500;

function randomVisitorId() {
  const bytes = new Uint8Array(16);
  window.crypto.getRandomValues(bytes);
  return Array.from(bytes, (byte) => byte.toString(16).padStart(2, "0")).join("");
}

function getVisitorId() {
  try {
    const existing = String(window.localStorage.getItem(VISITOR_KEY) || "").trim().toLowerCase();
    if (/^[a-f0-9]{32}$/.test(existing)) return existing;
    const next = randomVisitorId();
    window.localStorage.setItem(VISITOR_KEY, next);
    return next;
  } catch {
    return "";
  }
}

function isLikelyBot() {
  if (typeof navigator === "undefined") return true;
  if (navigator.webdriver) return true;
  const ua = String(navigator.userAgent || "");
  if (!ua || ua.length < 20) return true;
  if (!/mozilla|chrome|safari|firefox|edg/i.test(ua)) return true;
  return /bot\b|spider|crawler|headless|preview|lighthouse|pagespeed|puppeteer|playwright|selenium|webdriver/i.test(ua);
}

function normalizePath(raw) {
  const value = String(raw || "").split(/[?#]/)[0];
  if (!value) return "";
  if (value.length > 1) return value.replace(/\/+$/, "") || "/";
  return value;
}

function utmValue(key) {
  try {
    return new URLSearchParams(window.location.search).get(key) || "";
  } catch {
    return "";
  }
}

function shouldDedupe(path) {
  const now = Date.now();
  const last = recent.get(path) || 0;
  if (now - last < DEDUPE_MS) return true;
  recent.set(path, now);
  return false;
}

export function isStaticPublicPath(path) {
  return STATIC_PATHS.has(normalizePath(path));
}

export function trackPublicPageview({ path, title } = {}) {
  if (typeof window === "undefined") return;
  if (isLikelyBot()) return;
  if (window.self !== window.top) return;
  if (document.prerendering) return;

  const nextPath = normalizePath(path || window.location.pathname);
  if (!nextPath.startsWith("/") || nextPath.startsWith("/admin") || nextPath === "/login") return;
  if (shouldDedupe(nextPath)) return;

  const visitorId = getVisitorId();
  if (!visitorId) return;

  const body = {
    path: nextPath,
    title: String(title || document.title || "").trim().slice(0, 160),
    visitorId,
    referrer: String(document.referrer || "").slice(0, 300),
    utmSource: utmValue("utm_source"),
    utmMedium: utmValue("utm_medium"),
  };

  fetch(`${getApiBaseUrl()}/pageviews`, {
    method: "POST",
    headers: { "Content-Type": "application/json", Accept: "application/json" },
    body: JSON.stringify(body),
    keepalive: true,
  }).catch(() => {});
}
